import React, { useState, useEffect, useContext, useMemo } from "react";
import { Col, Row, Button, Form, Modal, Container } from "react-bootstrap";
import { useLocation, useNavigate } from 'react-router-dom';
import { getCDNImage } from '../../globals';
import { HotelContext } from "../../context/hotel";
import { useParams } from 'react-router';
import { T, TF } from "react-translator-component";
import Screen from '../../components/Screen';
import { useLanguage } from "../../hooks/useLanguage";
import useBookable from "../../hooks/useBookable";
import { calculateHoursUntil, formatDateFromLanguage, i18nValue, qtyText } from "../../functions";
import processHtml from "../../components/processHtml";


const ReservationDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { language: languageApp, setLanguage } = useLanguage()
  const { data: hotel, getUrlPath } = useContext(HotelContext);

  const [reservationData, setReservationData] = useState(null);
  const [loading, setLoading] = useState(true);

  const [showMessageExpired, setShowMessageExpired] = useState(false);
  const [showMessageConfirm, setShowMessageConfirm] = useState(false);
  const [showButtonConfirmed, setShowButtonConfirmed] = useState(false);
  const [confirmedData, setConfirmedData] = useState(null);

  const { getBookableReservation, confirmBookableReservation } = useBookable();

  useEffect(async () => {

    // Voy a buscar los datos de reserva
    const loading = await getData(id);
    setLoading(false);

  }, [id]);

  const language = useMemo(() => {

    console.log('currentLanguage - call');
    let curr = "en-US";

    if (reservationData?.language) {
      curr = reservationData.language;
    } else {
      if (languageApp) {
        curr = languageApp;
      }
    }

    console.log('currentLanguage', curr);
    return curr;

  }, [languageApp, reservationData])

  const getData = async (id) => {
    const res = await getBookableReservation(id);
    if (res) {
      console.log('0406 - getBookableReservation', res);
      if (res?.id) {
        setReservationData(res);

        if (res?.confirmed) {
          setConfirmedData(res.confirmed);
        } else {
          const dateBookableReservation = `${res.day} ${res.slot}`;
          console.log('0406 - dateBookableReservation', dateBookableReservation);
          const hours = calculateHoursUntil(dateBookableReservation);
          console.log('0406 - hours to bookable', hours);
          if (hours < 0) {
            // No muestro nada. Ya no se puede hacer nada con la reserva
            setShowMessageExpired(true);
          } else {
            if (hours > 72) {
              // No muestro botón y muestro mensaje
              setShowMessageConfirm(true);
              setShowButtonConfirmed(false);
            } else {
              setShowButtonConfirmed(true);
            }
          }
        }

      }
    }
  }

  const currentState = useMemo(() => {
    let auxCurrentState = reservationData?.status ?? "pending";
    if (confirmedData?.status) {
      auxCurrentState = "accepted";
    }
    return auxCurrentState;
  }, [reservationData, confirmedData]);

  const handleClickConfirm = async () => {
    const res = await confirmBookableReservation(id);
    console.log('res confirmBookableReservation', res);
    if (res?.data?.updateBookableReservation?.id) {
      getData(id);
    }
  }
  const handleClickGoToPublicDash = () => {
    navigate(getUrlPath(`/public_home/${reservationData?.Person?.id}`), { replace: true })
  }

  if (loading) {
    return <Screen
      section={`bookable_reservation`}
      title={String(T("general.reservation")).toUpperCase()}
      showBackButton={false}
      hideHeader={true}
    >
      <div className="loading text-center mt-5 p-10">
        <div className="spinner-border" role="status"></div>
      </div>
    </Screen>
  }

  return (
    <Screen
      section={`bookable_reservation`}
      title={String(T("general.reservation")).toUpperCase()}
      showBackButton={false}
      // backGroundImage={"https://images.rawpixel.com/image_1000/czNmcy1wcml2YXRlL3Jhd3BpeGVsX2ltYWdlcy93ZWJzaXRlX2NvbnRlbnQvbHIvcHgxMDE0MDA0LWltYWdlLWt3dnk3bXVrLmpwZw.jpg"}
      hideHeader={true}
    >
      <Container className="p-3 mt-4" style={{ maxWidth: 230, border: "1px solid #EEE", background: "#FFF", borderRadius: 8, marginBottom: 20 }}>
        <Row>
          <Col>
            <img className="w-100" src={getCDNImage(hotel.logo)} />
          </Col>
        </Row>
      </Container>

      {!reservationData && (
        <Container className="px-3 mt-4">
          <Row>
            <Col className="text-center">
              <div>{T("public.reservation.not-found")}</div>
            </Col>
          </Row>
        </Container>
      )}

      {reservationData && (
        <>
          <Container className="px-3 mt-4">
            <Row>
              <Col className="text-center">
                <p>{TF("public.reservation.welcome", reservationData.Person?.fullname)}</p>
              </Col>
            </Row>
          </Container>

          <Container style={{ maxWidth: 500, textAlign: "center" }}>
            <Row>
              <Col>
                <div className="text-center" style={{ maxWidth: 450 }}>

                  {/* <h5>{i18nValue(reservationData.BookableItem, 'name', language)}</h5> */}
                  {/* <p className="mb-3 font-xs">{T('general.from')} {reservationData.BookableItem.startHour}hs. {T('general.to')} {reservationData.BookableItem.endHour}hs. / {T('general.duration')}: {reservationData.BookableItem.durationToShow} min.</p> */}
                  {reservationData.BookableItem.photo && <img src={getCDNImage(reservationData.BookableItem.photo)} className="page-detail-photo w-48 mb-3" />}
                  {!reservationData.BookableItem.photo && <img src={'/logo_57.png'} className="page-detail-photo no-photo w-48 mb-3" />}

                  <div className="text-center" >

                    <div className="px-3 pb-3 mb-3 general-text-sm" style={{ border: "1px solid #EEE", background: "rgba(255, 255, 255, 0.8)", borderRadius: 8, paddingTop: "30px" }}>
                      <div className="d-flex justify-content-between mx-3" style={{ gap: 15 }}>
                        <div>
                          <div className="general-text-sm">{T("public.reservation.date-and-hour")}</div>
                          <div><b>{formatDateFromLanguage(`${reservationData.day} ${reservationData.slot}`, language)}</b></div>
                        </div>
                        <div>
                          <div className="general-text-sm">{T("public.reservation.people")}</div>
                          <div><b>{qtyText(reservationData.qty, reservationData.qtyAdults, reservationData.qtyChildren)}</b></div>
                        </div>
                        <div>
                          <div className="general-text-sm">{T("public.reservation.state")}</div>
                          <div><div className={`label label-sm label-light-${currentState} label-inline text-uppercase`}>{T(`services.status.${currentState == "accepted" ? "confirmed" : currentState}`)}</div></div>
                        </div>
                      </div>

                      {reservationData.observations && (
                        <div className="text-left mt-2 mx-3">
                          <div className="general-text-sm">{T("public.reservation.observations")}</div>
                          <div><b>{reservationData.observations}</b></div>
                        </div>
                      )}

                      {/* {(showMessageExpired) && (
                        <div className="text-center mt-4 font-size-normal text-muted">{T("public.reservation.expired")}</div>
                      )} */}

                      {(showMessageConfirm && !confirmedData) && (
                        <div className="text-center mt-4 font-size-normal">{T("public.reservation.confirm_msg")}</div>
                      )}
                      {(showButtonConfirmed && !confirmedData) && (
                        <Button
                          block={true}
                          className="mt-3 btn btn-accept btn-lg"
                          onClick={(e) => handleClickConfirm()}
                        >{String(T("public.reservation.confirm"))?.toUpperCase()}</Button>
                      )}

                      {confirmedData && (
                        <div className="text-center font-size-normal text-success mt-4">
                          {T('public.reservation.confirmated-at')} {formatDateFromLanguage(confirmedData.date, language)}
                        </div>
                      )}


                    </div>

                  </div>

                </div>

                <h5>{i18nValue(reservationData.BookableItem, 'name', language)}</h5>
                <p className="page-detail-description">{processHtml(i18nValue(reservationData.BookableItem, 'description', language))}</p>
              </Col>
            </Row>
          </Container>
        </>
      )}


      {/* <Container className="px-3" style={{ maxWidth: 500 }}>
        <Row>
          <Col lg={6} md={12} className="text-center">Tu reserva</Col>
        </Row>
      </Container> */}

      {/* <Container className="py-3" style={{ maxWidth: 500, border: "1px solid #EEE", background: "rgba(255, 255, 255, 0.8)", borderRadius: 8 }}>
        <Row>
          <Col lg={6} md={12} className="text-center">

            <div className="general-text-sm">Responsable</div>
            <div><b>{reservationData.Person?.fullname ?? "--"}</b></div>

            <div className="general-text-sm mt-3">Fecha y hora</div>
            <div><b>{reservationData.day} {reservationData.slot}</b></div>

            <div className="general-text-sm mt-3">Estado de la reserva</div>
            <div><b>{T(`services.status.${reservationData.status}`)}</b></div>

          </Col>
        </Row>

      </Container> */}


      {reservationData?.Person?.id && (
        <div className="footer-container">
          <Button
            block={true}
            className="w-100 btn btn-success btn-lg"
            onClick={(e) => handleClickGoToPublicDash()}
          >{String(T("public.reservation.view-reservations"))?.toUpperCase()}</Button>
        </div>
      )}

    </Screen>
  );
}

export default ReservationDetail;